module.exports = __webpack_public_path__ + "img/bg.0caf9ffd.png";